const autoNgTemplateLoaderTemplate1 = require('./sales-deposits.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.salesDeposits', [])
        .config(salesDepositsConfig);

    salesDepositsConfig.$inject = ['$routeProvider'];

    function salesDepositsConfig($routeProvider) {
        $routeProvider
            .when('/sales-deposits/from/:from/to/:to', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SalesDepositsController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
